var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom/24/qr-v2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75 8.75V4C2.75 3.66848 2.8817 3.35054 3.11612 3.11612C3.35054 2.8817 3.66848 2.75 4 2.75H8.75M21.25 8.75V4C21.25 3.66848 21.1183 3.35054 20.8839 3.11612C20.6495 2.8817 20.3315 2.75 20 2.75H15.25M21.25 15.25V20C21.25 20.3315 21.1183 20.6495 20.8839 20.8839C20.6495 21.1183 20.3315 21.25 20 21.25H15.25M2.75 15.25V20C2.75 20.3315 2.8817 20.6495 3.11612 20.8839C3.35054 21.1183 3.66848 21.25 4 21.25H8.75",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.25 8.75H10.75C9.64543 8.75 8.75 9.64543 8.75 10.75V13.25C8.75 14.3546 9.64543 15.25 10.75 15.25H13.25C14.3546 15.25 15.25 14.3546 15.25 13.25V10.75C15.25 9.64543 14.3546 8.75 13.25 8.75Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrCode);
export default __webpack_public_path__ + "static/media/icon-qr-code.c34372505c7cfb42ddcca696c10d5d75.svg";
export { ForwardRef as ReactComponent };